<!-- 产品服务 -->
<style scoped>
.productService {
    width: 100%;
}
.introduceA {
    width: 100%;
    padding: 40px 0;
    background-color: #ffffff;
}
.introduceA ul {
    display: -webkit-flex;
    display: flex;
    width: 1200px;
    margin: 0 auto;
    justify-content: space-between;
    -webkit-justify-content: space-between;
}
.introduceA ul li {
    display: inline-block;
    width: 390px;
    animation: dontSelectionPlay .2s forwards;
    -webkit-animation: dontSelectionPlay .2s forwards;
}
.introduceA ul li:hover {
    animation: selectionPlay .2s forwards;
    -webkit-animation: selectionPlay .2s forwards;
    box-shadow: 10px 0 10px #f4f6f8,-10px 0 10px #f4f6f8,0 10px 10px #f4f6f8,0 -10px 10px #f4f6f8;
    -webkit-box-shadow: 10px 0 10px #f4f6f8,-10px 0 10px #f4f6f8,0 10px 10px #f4f6f8,0 -10px 10px #f4f6f8;
}
.introduceA ul li img {
    width: 100%;
}
.introduceB {
    width: 100%;
    height: 668px;
    padding: 40px 0 0;
    background-color: #f0f0f0;
    overflow: hidden;
}
.introduceB .introduceBContent {
    width: 1200px;
    margin: 0 auto;
}
 .introduceBNavList {
    width: 100%;
    margin-top: 25px;
    border-bottom: 1px solid #d1d1d1;
}
 .introduceBNavList ul {
    display: -webkit-flex;
    display: flex;
    width: 985px;
    margin: 0 auto;
    padding: 10px 0;
    justify-content: space-between;
    -webkit-justify-content: space-between;
}
 .introduceBNavList ul li {
    position: relative;
    display: inline-block;
    cursor: pointer;
}
 .introduceBNavList ul li .selection {
    position: absolute;
    bottom: -11px;
    left: 0;
    width: 172px;
    height: 6px;
    background-image: url(../../assets/images/22_14.png);
    opacity: 0;
}
.introduceBNavList ul li.selectionType .selection {
    opacity: 1;
}
.introduceBNavList ul li i {
    display: inline-block;
    margin-right: 5px;
    vertical-align: middle;
}
.introduceBNavList ul li i.introduceBNavIcon1 {
    width: 30px;
    height: 28px;
    background-image: url(../../assets/images/introduceBNavIcon1.png);
}
.introduceBNavList ul li i.introduceBNavIcon2 {
    width: 30px;
    height: 26px;
    background-image: url(../../assets/images/introduceBNavIcon2.png);
}
.introduceBNavList ul li i.introduceBNavIcon3 {
    width: 30px;
    height: 26px;
    background-image: url(../../assets/images/introduceBNavIcon3.png);
}
.introduceBNavList ul li i.scenarios1 {
    width: 30px;
    height: 30px;
    background-image: url(../../assets/images/scenarios1.png);
    background-size: contain;
}
.introduceBNavList ul li i.scenarios2 {
    width: 30px;
    height: 30px;
    background-image: url(../../assets/images/scenarios2.png);
    background-size: contain;
}
.introduceBNavList ul li i.scenarios3 {
    width: 30px;
    height: 30px;
    background-image: url(../../assets/images/scenarios3.png);
    background-size: contain;
}
.introduceBNavList ul li i.VDscenarios1 {
    width: 30px;
    height: 30px;
    background-image: url(../../assets/images/VDscenarios1.png);
    background-size: contain;
}
.introduceBNavList ul li i.VDscenarios2 {
    width: 30px;
    height: 30px;
    background-image: url(../../assets/images/VDscenarios2.png);
    background-size: contain;
}
.introduceBNavList ul li i.VDscenarios3 {
    width: 30px;
    height: 30px;
    background-image: url(../../assets/images/VDscenarios3.png);
    background-size: contain;
}
.introduceBNavList ul li span {
    color: #000000;
    font-size: 18px;
    vertical-align: middle;
}
.introduceBNavList ul li.selectionType span {
    color: #04a0f7;
}
.introduceBNavList ul li span:hover {
    color: #04a0f7;
}
.introduceB .introduceBContent .introduceBType {
    width: 100%;
    height: 471px;
    margin: 30px auto 0;
}
.introduceB .introduceBContent .introduceBType ul {
    display: -webkit-flex;
    display: flex;
    width: 1100px;
    margin: 0 auto;
    justify-content: space-between;
    -webkit-justify-content: space-between;
}
.introduceB .introduceBContent .introduceBType ul li {
    display: inline-block;
    width: 273px;
}
.introduceB .introduceBContent .introduceBType ul li img {
    width: 100%;
}
.introduceB .introduceBContent .introduceBTypeB {
    width: 1200px;
    margin: 30px auto 0;
}
.introduceB .introduceBContent .introduceBTypeB p {
    color: #666666;
    font-size: 18px;
    text-align: center;
}
.introduceB .introduceBContent .introduceBTypeB ul {
    display: -webkit-flex;
    display: flex;
    width: 100%;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
}
.introduceB .introduceBContent .introduceBTypeB ul li {
    display: inline-block;
    width: 175px;
    margin-top: 15px;
}
.introduceB .introduceBContent .introduceBTypeB ul li img {
    width: 100%;
}
.introduceB .introduceBContent .introduceBList .introduceBType li {
    box-shadow: none;
    animation: dontSelectionPlayBtm .2s forwards;
    -webkit-animation: dontSelectionPlayBtm .2s forwards;
}
.introduceB .introduceBContent .introduceBList .introduceBType li:hover {
    animation: selectionPlayBtm .2s forwards;
    -webkit-animation: selectionPlayBtm .2s forwards;
}
.introduceB .introduceBContent .introduceBList .introduceBTypeB li {
    animation: dontSelectionPlay .2s forwards;
    -webkit-animation: dontSelectionPlay .2s forwards;
}
.introduceB .introduceBContent .introduceBList .introduceBTypeB li:hover {
    animation: selectionPlay .2s forwards;
    -webkit-animation: selectionPlay .2s forwards;
    box-shadow: 10px 0 10px #f4f6f8,-10px 0 10px #f4f6f8,0 10px 10px #f4f6f8,0 -10px 10px #f4f6f8;
    -webkit-box-shadow: 10px 0 10px #f4f6f8,-10px 0 10px #f4f6f8,0 10px 10px #f4f6f8,0 -10px 10px #f4f6f8;
}
.productServicebg {
    width: 100%;
    background: url(../../assets/images/productServiceBg.png)no-repeat center center;
    background-size: cover;
    background-position: 0 -218px;
}
.introduceC {
    padding-top: 60px;
    width: 1200px;
    margin: 0 auto;
}
.introduceC .introduceCContent {
    width: 100%;
    height: 581px;
    margin-top: 40px;
    font-size: 0;
}
.introduceC .introduceCContent .letNavbox {
    display: inline-block;
    width: 300px;
    border: 1px solid #e5e8ed;
    background-color: #ffffff;
    box-shadow: 5px 0 10px #e5e8ed,-5px 0 10px #e5e8ed,0 5px 10px #e5e8ed,0 -5px 10px #e5e8ed;
    -webkit-box-shadow: 5px 0 10px #e5e8ed,-5px 0 10px #e5e8ed,0 5px 10px #e5e8ed,0 -5px 10px #e5e8ed;
    vertical-align: top;
}
.introduceC .introduceCContent .letNavbox ul {
    width: 100%;
}
.introduceC .introduceCContent .letNavbox ul li {
    position: relative;
    display: block;
    width: 100%;
    height: 120px;
    padding: 20px 80px 0 18px;
    border-bottom: 1px solid #e5e8ed;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    cursor: pointer;
}
.introduceC .introduceCContent .letNavbox ul li:last-child {
    border-bottom: 0;
}
.introduceC .introduceCContent .letNavbox ul li h1 {
    color: #000000;
    font-size: 22px;
}
.introduceC .introduceCContent .letNavbox ul li p {
    margin-top: 10px;
    line-height: 24px;
    color: #666666;
    font-size: 14px;
}
.introduceC .introduceCContent .letNavbox ul li .leftNavIcon {
    position: absolute;
    top: 27px;
    right: 35px;
    display: inline-block;
    width: 38px;
    height: 38px;
    background-image: url(../../assets/images/leftNavIcon.png);
}
.introduceC .introduceCContent .letNavbox ul li.selection {
    background-image: -webkit-linear-gradient(to right, #2b7bff , #04a0f7);
    background-image: -moz-linear-gradient(to right, #2b7bff , #04a0f7);
    background-image: -o-linear-gradient(to right, #2b7bff , #04a0f7);
    background-image: linear-gradient(to right, #2b7bff , #04a0f7);
}
.introduceC .introduceCContent .letNavbox ul li.selection h1,
.introduceC .introduceCContent .letNavbox ul li.selection p {
    color: #ffffff;
}
.introduceC .introduceCContent .letNavbox ul li:hover {
    box-shadow: 2px 0 10px #d0cdcd,-2px 0 10px #d0cdcd,0 2px 10px #d0cdcd,0 -2px 10px #d0cdcd;
    -webkit-box-shadow: 2px 0 10px #d0cdcd,-2px 0 10px #d0cdcd,0 2px 10px #d0cdcd,0 -2px 10px #d0cdcd;
}
.introduceC .introduceCContent .letNavbox ul li.selection .leftNavIcon  {
    background-image: url(../../assets/images/leftNavIconSelection.png);
}
.introduceC .introduceCContent .rightContent {
    display: inline-block;
    width: 888px;
    height: 528px;
    margin-left: 12px;
    vertical-align: top;
    animation: dontSelectionPlay .2s forwards;
    -webkit-animation: dontSelectionPlay .2s forwards;
}
.introduceC .introduceCContent .rightContent:hover {
    animation: selectionPlay .2s forwards;
    -webkit-animation: selectionPlay .2s forwards;
}
.introduceC .introduceCContent .rightContent img {
    width: 100%;
}
.introduceD {
    width: 1200px;
    margin: 0 auto;
    padding-top: 45px;
}
.introduceD ul {
    display: -webkit-flex;
    display: flex;
    width: 100%;
    margin-top: 20px;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
}
.introduceD ul li {
    display: -webkit-inline-flex;
    display: inline-flex;
    width: 291px;
    height: 160px;
    margin-top: 12px;
    overflow-y: hidden;
    border: 1px solid #e5e8ed;
    border-radius: 5px;
    background-color: #ffffff;
    align-items: center;
    -webkit-align-items: center;
    justify-content: center;
    -webkit-justify-content: center;
    animation: dontSelectionPlay .2s forwards;
    -webkit-animation: dontSelectionPlay .2s forwards;
}
.introduceD ul li:hover {
    animation: selectionPlay .2s forwards;
    -webkit-animation: selectionPlay .2s forwards;
    box-shadow: 10px 0 10px #f4f6f8,-10px 0 10px #f4f6f8,0 10px 10px #f4f6f8,0 -10px 10px #f4f6f8;
    -webkit-box-shadow: 10px 0 10px #f4f6f8,-10px 0 10px #f4f6f8,0 10px 10px #f4f6f8,0 -10px 10px #f4f6f8;
}
.introduceD ul li img {
    display: block;
    width: 89px;
    height: 67px;
    margin: 0 auto;
}
.introduceD ul li p {
    margin-top: 20px;
    text-align: center;
    color: #000000;
    font-size: 16px;
}
.introduceE {
    position: relative;
    min-width: 1200px;
    width: 100%;
    height: 652px;
}
.introduceE .bgA {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 505px;
    background-color: #f0f0f0;
}
.introduceE .bgB {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 147px;
    background-color: #ffffff;
}
.introduceE .introduceEContent {
    position: relative;
    width: 1200px;
    margin: 0 auto;
    padding-top: 40px;
}
.introduceE .introduceEContent ul {
    display: -webkit-flex;
    display: flex;
    margin-top: 40px;
    justify-content: space-between;
    -webkit-justify-content: space-between;
}
.introduceE .introduceEContent ul li {
    display: inline-block;
    width: 289px;
    height: 452px;
    background-color: #ffffff;
    overflow: hidden;
    animation: dontSelectionPlay .2s forwards;
    -webkit-animation: dontSelectionPlay .2s forwards;
    box-shadow: 10px 0 10px #f4f6f8,-10px 0 10px #f4f6f8,0 10px 10px #f4f6f8,0 -10px 10px #f4f6f8;
    -webkit-box-shadow: 10px 0 10px #f4f6f8,-10px 0 10px #f4f6f8,0 10px 10px #f4f6f8,0 -10px 10px #f4f6f8;
}
.introduceE .introduceEContent ul li h1 {
    margin: 20px 0 10px;
    text-align: center;
    color: #000000;
    font-size: 22px;
}
.introduceE .introduceEContent ul li p {
  position: relative;
  color: #666666;
  font-size: 14px;
  padding: 0 23px 0 30px;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  text-align: left;
}
.introduceE .introduceEContent ul li p i {
  position: absolute;
  top: 0;
  left: 20px;
  display: inline-block;
  line-height: 26px;
}
.introduceE .introduceEContent ul li p span {
  line-height: 24px;
}
.introduceE .introduceEContent ul li:hover {
    animation: selectionPlay .2s forwards;
    -webkit-animation: selectionPlay .2s forwards;
}
.introduceE .introduceEContent ul li img {
    width: 100%;
}

.trial{
    background-color: #f2f1f2;
}
.trial .trialContent .form_txt{
    font-size: 16px;
}
.trial .trialContent {
    width: 1200px;
    margin: 0 auto;
    padding-top:28px ;
    padding-bottom: 70px;
    position: relative;
}
.trial .trialContent .title_text{
    text-align: center;
    color: #3A4654;
    font-size: 15px;
    padding: 16px 0 32px 0;
}
.trial .trialContent .content_box img{
    width: 597px;
    height: 435px;
    margin-top: 67px;
}
.trial .trialContent .form_box{
    width: 660px;
    height: 377px;
    background-color: #fff;
    position: absolute;
    top: 171px;
    right: 0;
    padding: 34px 54px;
}
.trial .trialContent .form_box .form_ok{
    text-align: center;
    padding-top: 100px;
}
.trial .trialContent .form_box .form_ok img{
    width: 80px;
    height: 80px;
}
.trial .trialContent .form_box .form_ok p{
    color: #aaa;
    margin-top: 30px;
}
.trial .trialContent .form_box label{
    display: block;
    width: 100%;
    margin-top: 10px;
}
.trial .trialContent .form_box input,
.trial .trialContent .form_box textarea{
    width: 419px;
    height: 38px;
    background-color: #F7F8F9;
    border: 1px solid #DDDDDD;
    padding-left: 10px;
}
.trial .trialContent .form_box textarea{
    height: 65px;
    resize: none;
    vertical-align: top;
}
.trial .trialContent .form_box span{
    display: inline-block;
    width: 70px;
    text-align: left;
}
.trial .trialContent .form_box .app_btn{
    display: inline-block;
    width: 419px;
    height: 43px;   
    background: #1791FF;
    border-radius: 4px;
    margin-left: 76px;
    margin-top: 18px;
    color: #fff;
    text-align: center;
    line-height: 43px;
    cursor: pointer;
}
.hearBgc{
    width: 100%;
    min-height: 332px;
    margin-top:80px ;
    background: url('../../assets/images/5GBgc.png') no-repeat;
    background-size: cover;
}
.hearBgc .heardCt{
    width: 1200px;
    margin: 0 auto;
}
.hearBgc .heardCt .til{
    font-size: 26px;
    color: #fff;
    padding-top: 66px;
    font-weight: bold;
}
.hearBgc .heardCt .ct{
    width: 528px;
    color: #fff;
    font-size: 13px;
    margin-top: 16px;
    line-height: 1.5;
}
.hearBgc .heardCt .btn{
    margin-top: 16px;
}
.hearBgc .heardCt .btn a{
    background-color: #fff;
    display: inline-block;
    padding: 8px 15px;
    font-size: 13px;
    border-radius: 5px;
}
.smsbgc{
    background: url('../../assets/images/SMSBgc.png') no-repeat;
    background-size: cover;
}
.vdbgc{
    background: url('../../assets/images/vdmsgBgc.png') no-repeat;
    background-size: cover;
}
.productAdvantage {
    padding-top: 32px;
    padding-bottom: 120px;
    background-color: #fff;
}
.productAdvantage .product_box{
    width: 1200px;
    margin: 0 auto;
}
.productAdvantage .product_box .product_content{
    margin-top: 65px;
}
.productAdvantage .product_box .product_u{
    display: flex;
    justify-content: space-around;
}
.productAdvantage .product_box .product_u li{
    width: 163px;
    text-align: center;
}
.productAdvantage .product_box .product_u li:hover{
    animation: selectionPlay .2s forwards;
    -webkit-animation: selectionPlay .2s forwards;
}
.productAdvantage .product_box .product_u li img{
    width: 71px;
    height: 71px;
}
.productAdvantage .product_box .product_u li .tli{
    font-size: 16px;
    color: #000000;
    line-height: 30px;
}
.productAdvantage .product_box .product_u li .tex{
    font-size: 13px;
    color: #666666;
    line-height: 1.5;
}
.appScenarios{
    background: url('../../assets/images/becomeDeveloperBg.png') no-repeat;
    background-size: cover;
    padding-top: 32px;
    height: 588px;
    overflow: hidden;
}
.appScenarios .scenarios_box{
    width: 1200px;
    margin: 0 auto;
}
.appScenarios .scenarios_box .scenariosNav_ct li .img_box:hover{
    animation: selectionPlayBtm .2s forwards;
    -webkit-animation: selectionPlayBtm .2s forwards;
}
.appScenarios .scenarios_box .scenariosNav_ct li .img_box{
    display: inline-block;
    padding: 44px 74px 0 150px;
}
.appScenarios .scenarios_box .scenariosNav_ct li img{
    width: 244px;
    height: 380px;
}
.appScenarios .scenarios_box .scenariosNav_ct li .ct{
    /* float: right; */
    display: inline-block;
    vertical-align: top;
    margin-top: 108px;
}
.appScenarios .scenarios_box .scenariosNav_ct li .ct .til{
    font-size: 24px;
    color: #000;
    font-weight: bold;
}
.appScenarios .scenarios_box .scenariosNav_ct li .ct .text{
    font-size: 14px;
    color: #666660;
    line-height: 22px;
    width: 500px;
    margin: 14px 0 27px 0;
}
.appScenarios .scenarios_box .scenariosNav_ct li .ct .ft{
    width: 209px;
    height: 95px;
    font-size: 14px;
    color: #666660;
    line-height: 34px;
}
.appScenarios .scenarios_box .scenariosNav_ct li .ct .ft span:nth-child(2n){
    margin-left: 68px;
}
.VDproductAdvantage{
    padding:0 0 54px 0;
    background-color: #f0f0f0;
    position: relative;
}
.VDproductAdvantage  .bgc_fff{
    height: 295px;
    background-color: #fff;
}
.VDproductAdvantage .VDproduct_box{
    width: 1200px;
    margin: 0 auto;
    position: relative;
    top: -260px;
    left: 0;
}

.VDproductAdvantage .VDproduct_box .VDproduct_ct{
    margin-top: 27px;
}
.VDproductAdvantage .VDproduct_box .VDproduct_u{
    display: flex;
    justify-content: space-around;
}
.VDproductAdvantage .VDproduct_box .VDproduct_u li{
    background-color: #fff;
}
.VDproductAdvantage .VDproduct_box .VDproduct_u li:hover{
    animation: selectionPlay .2s forwards;
    -webkit-animation: selectionPlay .2s forwards;
}
.VDproductAdvantage .VDproduct_box .VDproduct_u li img{
    width: 350px;
    height: 217px;
}
.VDproductAdvantage .VDproduct_box .VDproduct_u .VDproduct_text{
    width: 350px;
    padding: 27px 30px 0;
}
.VDproductAdvantage .VDproduct_box .VDproduct_u .VDproduct_text .til{
    font-size: 22px;
    color: #000000;
    line-height: 28px;
    margin-bottom: 9px;
}
.VDproductAdvantage .VDproduct_box .VDproduct_u .VDproduct_text .text{
    font-size: 14px;
    color: #666666;
    line-height: 22px;
    margin-bottom: 18px;
}
.VDappScenarios{
    background: url('../../assets/images/becomeDeveloperBg.png') no-repeat;
    background-size: cover;
    width: 100%;
    padding-top: 31px;
    height: 580px;
    position: relative;
    bottom: 252px;
    left: 0;
    overflow: hidden;
}
.VDappScenarios .VDappScenarios_box{
    width: 1200px;
    margin: 0 auto;
}
.VDappScenarios .VDappScenarios_box .VDappScenariosNav_u .img_box{
    padding: 36px 30px 0;
    display: inline-block;
}
.VDappScenarios .VDappScenarios_box .VDappScenariosNav_u .img_box img{
    width: 244px;
    height: 380px;
    margin: 0 20px;
}
.VDappScenarios .VDappScenarios_box .VDappScenariosNav_u .img_box img:hover{
    animation: selectionPlayBtm .2s forwards;
    -webkit-animation: selectionPlayBtm .2s forwards;
}

.VDappScenarios .VDappScenarios_box .VDappScenariosNav_u .ct_text{
    display: inline-block;
    vertical-align: top;
    margin-top: 94px;
    margin-left: 30px;
}
.VDappScenarios .VDappScenarios_box .VDappScenariosNav_u .ct_text .til{
    font-size: 24px;
    color: #666666;
    line-height: 32px;
    margin-bottom: 18px;
}
.VDappScenarios .VDappScenarios_box .VDappScenariosNav_u .ct_text .text{
    width: 300px;
    font-size: 14px;
    color: #000;
    
}
.VDappScenarios .VDappScenarios_box .VDappScenariosNav_u .ct_text .text span{
    display: inline-block;
    width: 100px;
    line-height: 30px;
}
.VDappScenarios .VDappScenarios_box .VDappScenariosNav_u .ct_text .text span:nth-child(2n){
    margin-left: 60px;
}
</style>
<template>
    <div class="productService">
        <hearder @childNumber='childNumber'></hearder>
        <div class="hearBgc" v-if="selChild == 0">
            <div class="heardCt" >
                <p class="til">
                    5G消息
                </p>
                <p class="ct">
                    5G消息，是运营商的一种全新基础电信服务，基于IP技术实现业务体验的飞跃，支持的媒体格式更多，表现形式更丰富，互动性更强。5G消息可使用户在消息窗口内就能完成服务搜索、交互、支付等一站式的业务体验，适用于各类行业的一站式用户服务场景。
                </p>
                <p class="btn">
                    <a href="http://5gm.richinfo.cn/dist/index.html#/register" target="_blank">免费试用</a>
                    <!-- <span>免费试用</span> -->
                </p>
            </div>
        </div>
        <div class="hearBgc smsbgc" v-else-if="selChild == 1">
            <div class="heardCt">
                <p class="til">
                    短信
                </p>
                <p class="ct">
                    短信可广泛应用于会员验证、订单通知、支付确认、物流提醒等信息触达、通知类场景。
                        如：短信验证码 、短信通知、推广短信等。
                </p>
                <p class="btn">
                    <a href="http://5gm.richinfo.cn/dist/index.html#/register" target="_blank">免费试用</a>
                </p>
            </div>
        </div>
        <div class="hearBgc vdbgc" v-else-if="selChild == 2">
            <div class="heardCt">
                <p class="til">
                    视频短信
                </p>
                <p class="ct">
                    视频短信是一款可以发视频的短信，相较于传统的文字短信，视频短信支持视频、图片和文本，能有丰富的展现方式和强烈的视觉冲击，适用于产品营销、品牌宣传等业务场景。
                </p>
                <p class="btn">
                    <a href="http://5gm.richinfo.cn/dist/index.html#/register" target="_blank">免费试用</a>
                </p>
            </div>
        </div>

        <!-- <div class="introduceA">
            <ul>
                <li>
                    <img src="@/assets/images/a_product1.png" alt="" />
                </li>
                <li>
                    <img src="@/assets/images/a_product2.png" alt="" />
                </li>
                <li>
                    <img src="@/assets/images/a_product3.png" alt="" />
                </li>
            </ul>
        </div> -->
        

        <!-- 产品优势 短信 -->
        <div class="productAdvantage" v-if="selChild == 1">
            <div class="product_box">
                <modularTit :titleName="'产品优势'"></modularTit>
                <div class="product_content">
                    <ul class="product_u">
                        <li>
                            <img src="@/assets/images/produt1.png" alt="">
                            <p class="tli">全网覆盖</p>
                            <p class="tex">移动、联通、电信三网，全号段覆盖</p>
                        </li>
                        <li>
                            <img src="@/assets/images/produt2.png" alt="">
                            <p class="tli">高达到率99.9%</p>
                            <p class="tex">多通道智能切换，保障高到达率</p>
                        </li>
                        <li>
                            <img src="@/assets/images/produt3.png" alt="">
                            <p class="tli">接入快速</p>
                            <p class="tex">文档完善快速接入，签名模板快速完成审核</p>
                        </li>
                        <li>
                            <img src="@/assets/images/produt4.png" alt="">
                            <p class="tli">主备通道</p>
                            <p class="tex">文档完善快速接入，签名模板快速完成审核</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 应用场景 短信 -->
        <div class="appScenarios" v-if="selChild == 1">
            <div class="scenarios_box">
                <modularTit :titleName="'应用场景'"></modularTit>
                <div class="scenarios_nav">
                    <div class="introduceBNavList">
                        <ul>
                            <li 
                                v-for="(item,index) in scenariosBNavList" 
                                :key="index" 
                                :class="{'selectionType': scenariosType === index}" 
                                @click="scenariosNowType(index)">
                                <i :class="item.typeClass"></i>
                                <span>{{item.name}}</span>
                                <b class="selection"></b>
                            </li>
                        </ul>
                    </div>
                    <div class="scenariosNav_ct">
                        <ul>
                            <li v-show="scenariosType == 0">
                                <div class="img_box"><img src="../../assets/images/scenarios1_pho.png" alt=""></div>
                                <div class="ct">
                                    <p class="til">短信验证码</p>
                                    <p class="text">提供三网合一的高质量专用通道，5S秒内必达，多级安全保护；适用于注册登录验证，找回密码，支付认证等场景</p>
                                    <p class="ft">
                                        <span>• 用户注册 </span>
                                        <span>• 手机绑定</span>
                                        <span>• 安全登录</span>
                                        <span>• 身份验证 </span>
                                        <span>• 找回密码</span>
                                        <span>• 支付认证</span>
                                    </p>
                                </div>
                            </li>
                            <li v-show="scenariosType == 1">
                                <div class="img_box"><img src="../../assets/images/scenarios2_pho.png" alt=""></div>
                                <div class="ct">
                                    <p class="til">系统通知推送</p>
                                    <p class="text">提供通知类文字短信服务，三网合一的高质量专用通道，多级安全保护；签名、模板配置简单，审核快速。适用于服务通知、物流通知、系统通知等应用场景。</p>
                                    <p class="ft">
                                        <span>• 订单通知 </span>
                                        <span>• 认证通知</span>
                                        <span>• 物流通知</span>
                                        <span>• 支付通知 </span>
                                        <span>• 系统通知</span>
                                        <span>• 账单通知</span>
                                    </p>
                                </div>
                            </li>
                            <li v-show="scenariosType == 2">
                                <div class="img_box"><img src="../../assets/images/scenarios3_pho.png" alt=""></div>
                                <div class="ct">
                                    <p class="til">业务营销推广</p>
                                    <p class="text">提供运营类文字短信服务，内置内容模板，三网合一的高质量专用通道，多级安全保护；适用于会员服务、客户关怀、新品发布等使用场景。</p>
                                    <p class="ft">
                                        <span>• 会员服务 </span>
                                        <span>• 优惠通知</span>
                                        <span>• 客户关怀</span>
                                        <span>• 礼品消息 </span>
                                        <span>• 新品上线</span>
                                        <span>• 节日回馈</span>
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                
            </div>
        </div>

        <div style="position: relative;height:1249px;" v-if="selChild == 2">
            <!-- 产品优势 视频短信 -->
            <div class="VDproductAdvantage" v-if="selChild == 2">
                <div class="bgc_fff"></div>
                <div class="VDproduct_box">
                    <modularTit :titleName="'产品优势'"></modularTit>
                    
                    <div class="VDproduct_ct">
                        <ul class="VDproduct_u">
                            <li>
                                <img src="@/assets/images/VDproduct1.png" alt="">
                                <div class="VDproduct_text">
                                    <p class="til">
                                        优：用户体验更优
                                    </p>
                                    <p class="text">● 丰富的富媒体内容，支持高清图片、高清音视频、超长文本等</p>
                                    <p class="text">● 较传统短信 ，视觉效果冲击力更强，用户不产生额外的用户流量费用，带来更高查看及点击，营销效果更好</p>
                                    <p class="text">● 具备多样化的交互方式，为用户带来更好的沟通体验</p>
                                </div>
                            </li>
                            <li>
                                <img src="@/assets/images/VDproduct2.png" alt="">
                                <div class="VDproduct_text">
                                    <p class="til">
                                        便：运营使用更方便
                                    </p>
                                    <p class="text">● 运营及时响应内容报备，7*24响应机制高效审核</p>
                                    <p class="text">● 提供专业的营销咨询，平台内置数据营销服务，提供数据支撑指导能力</p>
                                    <p class="text">● 提供行业投递方案，使得转化效果更佳</p>
                                </div>
                            </li>
                            <li>
                                <img src="@/assets/images/VDproduct3.png" alt="">
                                <div class="VDproduct_text">
                                    <p class="til">
                                        高：高覆盖率+高到达率
                                    </p>
                                    <p class="text">● 用户无需更新新款手机终端，无需下载APP或者关注公众号，即可收到视频短信</p>
                                    <p class="text">● 用户群体广，兼容支持Android和iOS系统，都可收取视频短信</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- 应用场景 视频短信 -->
            <div class="VDappScenarios" v-if="selChild == 2">
                <div class="VDappScenarios_box">
                    <modularTit :titleName="'应用场景'"></modularTit>
                    <div class="VDappScenarios_nav">
                        <div class="introduceBNavList">
                            <ul>
                                <li 
                                    v-for="(item,index) in VDscenariosBNavList" 
                                    :key="index" 
                                    :class="{'selectionType': VDscenariosType === index}" 
                                    @click="VDscenariosNowType(index)">
                                    <i :class="item.typeClass"></i>
                                    <span>{{item.name}}</span>
                                    <b class="selection"></b>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="VDappScenariosNav_ct">
                        <ul class="VDappScenariosNav_u">
                            <li v-show="VDscenariosType == 0">
                                <div class="img_box">
                                    <img src="../../assets/images/VDappScenarios1-1.png" alt="">
                                    <img src="../../assets/images/VDappScenarios1-2.png" alt="">
                                </div>
                                <div class="ct_text">
                                    <p class="til">适用场景</p>
                                    <p class="text">
                                        <span>•  活动营销</span>
                                        <span>•  积分回馈</span>
                                        <span>•  账单还款提醒</span>
                                        <span>•  APP推广</span>
                                        <span>•  会员专享</span>
                                        <span>•  互动抽奖</span>
                                        <span>•  基金推荐</span>
                                    </p>
                                </div>
                            </li>
                            <li v-show="VDscenariosType == 1">
                                <div class="img_box">
                                    <img src="../../assets/images/VDappScenarios2-1.png" alt="">
                                    <img src="../../assets/images/VDappScenarios2-2.png" alt="">
                                </div>
                                <div class="ct_text">
                                    <p class="til">适用场景</p>
                                    <p class="text">
                                        <span>•  节日大促</span>
                                        <span>•  拼团提醒</span>
                                        <span>•  新品推荐</span>
                                        <span>•  预购提醒</span>
                                        <span>•  商品直购</span>
                                        <span>•  领取津贴礼券</span>
                                        <span>•  会员回馈 </span>
                                        <span>•  商品限时开抢</span>
                                        <span>•  服务通知</span>
                                    </p>
                                </div>
                            </li>
                            <li v-show="VDscenariosType == 2">
                                <div class="img_box">
                                    <img src="../../assets/images/VDappScenarios3-1.png" alt="">
                                    <img src="../../assets/images/VDappScenarios3-2.png" alt="">
                                </div>
                                <div class="ct_text">
                                    <p class="til">适用场景</p>
                                    <p class="text">
                                        <span>•  菜品推荐</span>
                                        <span>•  消费提醒</span>
                                        <span>•  新品上线打折</span>
                                        <span>•  附近商家推荐</span>
                                        <span>•  活动预订</span>
                                        <span>•  会员回馈</span>
                                        <span>•  优惠券赠送 </span>
                                        <span>•  用户调查</span>
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <!-- 5G消息制作与发送 -->
        <div class="introduceB" v-if="selChild ==0">
            <div class="introduceBContent">
                <modularTit :titleName="'5G消息制作与发送'"></modularTit>
                <div class="introduceBNav">
                    <div class="introduceBNavList">
                        <ul>
                            <li 
                                v-for="(item,index) in introduceBNavList" 
                                :key="index" 
                                :class="{'selectionType': selectionType === index}" 
                                @click="selectionNowType(index)">
                                <i :class="item.typeClass"></i>
                                <span>{{item.name}}</span>
                                <b class="selection"></b>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="introduceBList">
                    <div class="introduceBType" v-show="selectionType === 0">
                        <ul>
                            <li>
                                <img src="@/assets/images/introduceBTypeAIcon1.png" />
                            </li>
                            <li>
                                <img src="@/assets/images/introduceBTypeAIcon2.png" />
                            </li>
                            <li>
                                <img src="@/assets/images/introduceBTypeAIcon3.png" />
                            </li>
                        </ul>
                    </div>
                    <div class="introduceBTypeB" v-show="selectionType === 1">
                        <p>海量行业模板，支持一键导入使用，方便快捷。</p>
                        <ul>
                            <li>
                                <img src="@/assets/images/introduceBTypeBIcon1.png" />
                            </li>
                            <li>
                                <img src="@/assets/images/introduceBTypeBIcon2.png" />
                            </li>
                            <li>
                                <img src="@/assets/images/introduceBTypeBIcon3.png" />
                            </li>
                            <li>
                                <img src="@/assets/images/introduceBTypeBIcon4.png" />
                            </li>
                            <li>
                                <img src="@/assets/images/introduceBTypeBIcon5.png" />
                            </li>
                            <li>
                                <img src="@/assets/images/introduceBTypeBIcon6.png" />
                            </li>
                            <li>
                                <img src="@/assets/images/introduceBTypeBIcon7.png" />
                            </li>
                            <li>
                                <img src="@/assets/images/introduceBTypeBIcon8.png" />
                            </li>
                            <li>
                                <img src="@/assets/images/introduceBTypeBIcon9.png" />
                            </li>
                            <li>
                                <img src="@/assets/images/introduceBTypeBIcon10.png" />
                            </li>
                            <li>
                                <img src="@/assets/images/introduceBTypeBIcon11.png" />
                            </li>
                            <li>
                                <img src="@/assets/images/introduceBTypeBIcon12.png" />
                            </li>
                        </ul>
                    </div>
                    <div class="introduceBType" v-show="selectionType === 2">
                        <ul>
                            <li>
                                <img src="@/assets/images/introduceBTypeCIcon1.png" />
                            </li>
                            <li>
                                <img src="@/assets/images/introduceBTypeCIcon2.png" />
                            </li>
                            <li>
                                <img src="@/assets/images/introduceBTypeCIcon3.png" />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- 垂直行业chatbot -->
        <div class="productServicebg" v-if="selChild ==0">
            <div class="introduceC">
                <modularTit :titleName="'垂直行业chatbot'"></modularTit>
                <div class="introduceCContent">
                    <div class="letNavbox">
                        <ul>
                            <li 
                                v-for="(item,index) in introduceCNavList" 
                                :key="index" 
                                :class="{'selection': introduceCNavS === index}" 
                                @click="switchIntroduceCNav(index)">
                                <h1>{{item.title}}</h1>
                                <p>{{item.tips}}</p>
                                <i class="leftNavIcon"></i>
                            </li>
                        </ul>
                    </div>
                    <div class="rightContent">
                        <img v-show="introduceCNavS === 0" src="@/assets/images/introduceCType1.png" />
                        <img v-show="introduceCNavS === 1" src="@/assets/images/introduceCType2.png" />
                        <img v-show="introduceCNavS === 2" src="@/assets/images/introduceCType3.png" />
                        <img v-show="introduceCNavS === 3" src="@/assets/images/introduceCType4.png" />
                    </div>
                    <!-- <img src="@/assets/images/introduceCContent.png" /> -->
                </div>
            </div>
            
            <!-- <div class="introduceD">
                    <modularTit :titleName="'增值服务'"></modularTit>
                    <ul>
                        <li>
                            <div>
                                <img src="@/assets/images/introduceD1.png" />
                                <p>智能聊天机器人</p>
                            </div>
                        </li>
                        <li>
                            <div>
                                <img src="@/assets/images/introduceD2.png" />
                                <p>图像识别</p>
                            </div>
                        </li>
                        <li>
                            <div>
                                <img src="@/assets/images/introduceD3.png" />
                                <p>语音识别</p>
                            </div>
                        </li>
                        <li>
                            <div>
                                <img src="@/assets/images/introduceD4.png" />
                                <p>身份认证</p>
                            </div>
                        </li>
                        <li>
                            <div>
                                <img src="@/assets/images/introduceD5.png" />
                                <p>中间号</p>
                            </div>
                        </li>
                        <li>
                            <div>
                                <img src="@/assets/images/introduceD6.png" />
                                <p>自有短信通道回落</p>
                            </div>
                        </li>
                        <li>
                            <div>
                                <img src="@/assets/images/introduceD7.png" />
                                <p>内容智能审核</p>
                            </div>
                        </li>
                        <li>
                            <div>
                                <img src="@/assets/images/introduceD8.png" />
                                <p>短信小程序</p>
                            </div>
                        </li>
                    </ul>
            </div> -->
        </div>

        <!-- 试用申请 -->
        <div class="trial">
            <div class="trialContent">
                <modularTit :titleName="'申请试用'"></modularTit>
                <!-- <div class="title_text">短信，可广泛应用于各种场景，常用于短信验证码、短信通知、推广短信。</div> -->
                <div class="content_box">
                    <img src="@/assets/images/trialContent.png" alt="">

                    <div class="form_box">
                        <div class="form_ok" v-if="istrial">
                            <img src="../../assets/images/form_icon.png" alt="">
                            <p>已经提交申请，运营人员将在3-5个工作日内联系您。</p>
                        </div>
                        <div class="form_txt" v-else>
                            <p>您好，请您填写试用申请，我们的客服将尽快联系您~</p>
                            <label>
                                <span><i style="color:red;">*</i>手机:</span>
                                <input v-model.trim="phon" type="text">
                            </label>
                            <label>
                                <span><i style="color:red;">*</i>邮箱:</span>
                                <input v-model.trim="eilm" type="text">
                            </label>
                            <label>
                                <span><i style="color:red;">*</i>公司:</span>
                                <input v-model.trim="name" type="text">
                            </label>
                            <label>
                                <span><i style="color:#fff;">*</i>需求:</span>
                                <textarea></textarea>
                            </label>
                            <spna class="app_btn" @click="chtrial">申请试用</spna>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
        

        <!-- <div class="introduceE">
            <div class="bgA"></div>
            <div class="bgB"></div>
            <div class="introduceEContent">
                <modularTit :titleName="'Open API'"></modularTit>
                <ul>
                    <li>
                        <img src="@/assets/images/introduceE1.png" />
                        <h1>提供Portal</h1>
                        <p><i>·</i><span>面向中小行业客户，通过Portal平台即可实现全流程的消息下发和管理。</span></p>
                        <p><i>·</i><span>平台提供包括应用、内容、消息、任务等全流程的可视化配置和管理。</span></p>
                    </li>
                    <li>
                        <img src="@/assets/images/introduceE2.png" />
                        <h1>标准API接入</h1>
                        <p><i>·</i><span>面向一般客户，提供标准API与其业务平台对接，实现多种类型的消息处理。</span></p>
                        <p><i>·</i><span>平台提供内容创建、多消息格式下发、消息上行推送、接口回执推送等标准化接口。</span></p>
                    </li>
                    <li>
                        <img src="@/assets/images/introduceE3.png" />
                        <h1>定制化API接入</h1>
                        <p><i>·</i><span>面向有定制需要的客户，平台可根据客户侧原有业务接口进行定制开发。</span></p>
                        <p><i>·</i><span>平台提供基于客户原有业务流程做消息封装转发，减少客户侧的开发成本。</span></p>
                    </li>
                    <li>
                        <img src="@/assets/images/introduceE4.png" />
                        <h1>配置化API接入</h1>
                        <p><i>·</i><span>面向业务体系化的客户，平台提供自定义接口创建，减少双方的定制化开发工作。</span></p>
                        <p><i>·</i><span>平台提供自定义创建和配置接口，关联消息下发环节，实现配置化API接入。</span></p>
                    </li>
                </ul>
            </div>
        </div> -->
        <!-- 申请试用 -->
        
        <introduce></introduce>
        <ctServich></ctServich>
        <backToTop></backToTop>
        <videoBox></videoBox>
    </div>
</template>
<script>
import hearder from '@/components/hearder'
import modularTit from '@/components/modularTit'
import introduce from "@/components/introduce.vue"
import videoBox from "@/components/videoBox.vue"
import backToTop from "@/components/backToTop.vue"
import ctServich from "@/components/ctServich.vue"
export default {
    name: 'productService',
    components: {
        hearder,
        modularTit,
        introduce,
        videoBox,
        backToTop,
        ctServich
    },
    data () {
        return {
            phon:'',
            eilm:'',
            name:'',
            istrial:false,
            selectionType: 0,
            introduceBNavList: [
                {
                    id: 1,
                    name: '场景化消息下发',
                    typeClass: 'introduceBNavIcon1'
                },
                {
                    id: 2,
                    name: '行业模板库',
                    typeClass: 'introduceBNavIcon2'
                },
                {
                    id: 3,
                    name: '三级回落机制',
                    typeClass: 'introduceBNavIcon3'
                }
            ],
            scenariosType:0,
            scenariosBNavList:[
                {
                    id: 1,
                    name: '短信验证码',
                    typeClass: 'scenarios1'
                },
                {
                    id: 2,
                    name: '系统通知推送',
                    typeClass: 'scenarios2'
                },
                {
                    id: 3,
                    name: '业务营销推广',
                    typeClass: 'scenarios3'
                },
            ],
            VDscenariosType:0,
            VDscenariosBNavList:[
                {
                    id: 1,
                    name: '金融行业',
                    typeClass: 'VDscenarios1'
                },
                {
                    id: 2,
                    name: '电商行业',
                    typeClass: 'VDscenarios2'
                },
                {
                    id: 3,
                    name: '餐饮行业',
                    typeClass: 'VDscenarios3'
                },
            ],
            introduceCNavS: 0,
            introduceCNavList: [
                {
                    title: '接入方案',
                    tips: '定制接入客户自由chatbot、平台标准化chatbot'
                },
                {
                    title: '行业知识图谱',
                    tips: '平台标准化chatbot具备垂直行业属性，结构行业知识图谱'
                },
                {
                    title: '闲聊库',
                    tips: '客户可在CSP平台创建与管理自身业务词库，定制问题解答'
                },
                {
                    title: 'NLP',
                    tips: '基于NLP，深度卷积神经网络内核，自动识别用户问题中参数'
                }
            ],
            selChild:0,
        }
    },
    methods: {
        selectionNowType(index) {
            if (this.selectionType === index) return;
            this.selectionType = index;
        },
        scenariosNowType(index){
            if (this.scenariosType === index) return;
            this.scenariosType = index;
        },
        VDscenariosNowType(index){
            if (this.VDscenariosType === index) return;
            this.VDscenariosType = index;
        },
        switchIntroduceCNav(index) {
            this.introduceCNavS = index;
        },
        childNumber(index){
            console.log(index);
            this.selChild = index;
        },
        chtrial(){
            if(this.phon == '' || this.eilm == '' || this.name == '') return;
            this.istrial = !this.istrial;
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/pages/productService/index.vue